import createAction from '../../app/services/create-action';

export const APP_SETTINGS_MODAL_OPENED = 'appSettingsModal/OPENED';

export default createAction(APP_SETTINGS_MODAL_OPENED);
